module.exports = __webpack_public_path__ + "img/KW.05b82052.svg";